export default {
  lang: "en",
  messages: {
    /* eslint-disable max-len */
    "app.title": "CAPE",
    "app.copyright": " {copyrightYear} International Post Corporation",
    "app.example.do-action": "Do Action",
    "error.credentials.invalid":
      "The username and/or password is incorrect . Please try again. If the problem persists please contact the IPC Help Desk at helpdesk@ipc.be.",
    "error.response is undefined":
      "A system issue has prevented a successful logon for you. Please try again. If the problem persists more than five minutes please notify the IPC Help Desk at helpdesk@ipc.be.",
    "Unable to get property 'status' of undefined or null reference":
      "A system issue has prevented a successful logon for you. Please try again. If the problem persists more than five minutes please notify the IPC Help Desk at helpdesk@ipc.be.",
    "app.signOut": "Sign Out",
    "app.button.cancel": "cancel",
    "app.button.close": "close",
    "app.button.next": "next",
    "app.button.save": "save",
    "app.button.add": "add",
    "app.button.edit": "edit",
    "app.button.remove": "remove",
    "app.button.search": "search",
    "app.button.ok": "OK",
    "app.button.yes": "Yes",
    "app.button.no": "No",
    "app.button.legend": "Legend",
    "app.button.email": "Email",
    "app.button.generate.on-screen.button": "On screen",
    "app.button.generate.email.button": "E-mail",
    "app.button.paper-free": "Request paper free route creation",
    "app.button.numbered": "123",
    "app.button.show.details": "show details",
    "app.button.hide.details": "hide details",
    "app.field.mandatory.selectionName": "Description is mandatory",
    "app.field.not.blank.selectionName":
      "Description with only spaces are not allowed",
    "app.field.max.length.selectionName":
      "Description must be {maxLength} characters or less",
    "app.field.already.used.selectionName": "Description is already in use",
    "app.field.mandatory": "{field} is mandatory",
    "app.field.not.blank": "{field} with only spaces are not allowed",
    "app.field.max.length": "{field} must be {maxLength} characters or less",
    "app.field.already.used": "{field} is already in use",
    "app.no.impcs.selected": "You must select at least 1 IMPC",
    "app.no.carriers.selected": "You must select at least 1 Carrier",
    "app.no.handlers.selected": "You must select at least 1 Handler",
    "app.no.mailbox.selected": "You must select at least 1 Mailbox",
    "app.no.unlocode.selected": "You must select at least 1 Unlocode",
    "app.no.mailsubclasses.selected":
      "You must select at least 1 mail sub class",
    "app.wizard.button.generate-report": "Generate report",
    "app.wizard.button.back-to-report": "Back To report",
    "app.save.selection.button.label": "Save Selection",
    "app.delete.selection.button.label": "Delete Selection",
    "app.save.impc.selection.form.title": "Save operator list",
    "app.edit.impc.selection.form.title": "Edit operator list",
    "app.save.mrd.impc.selection.form.title": "Save MRD list",
    "app.edit.mrd.impc.selection.form.title": "Edit MRD list",
    "app.save.carrier.selection.form.title": "Save carrier list",
    "app.save.handler.selection.form.title": "Save handler list",
    "app.save.mailbox.selection.form.title": "Save operator list",
    "app.edit.mailbox.selection.form.title": "Edit operator list",
    "app.save.despatch.selection.form.title": "Save Despatch Type List",
    "app.edit.despatch.selection.form.title": "EditDespatch Type List",
    "app.save.unlocode.selection.form.title": "Save location list",
    "app.edit.unlocode.selection.form.title": "Edit location list",
    "app.save.product.selection.form.title": "Save products",
    "app.edit.product.selection.form.title": "Edit products",
    "app.save.empty.new.preset": "New empty preset",
    "app.save.selection.form.name": "Name",
    "app.save.selection.form.selectionName": "Description",
    "app.selection.list.title.carrier": "Carrier List",
    "app.selection.list.title.handler": "Handler List",
    "app.selection.list.title.label": "Select on {operatorType} list",
    "app.selection.list.empty": "No selections found",
    "app.selection.list.lastSelection": "Your last selection",
    "app.selection.new.preset": "New Empty Preset",
    "app.selection.admin.list.operatorimpc.title.label":
      "SELECT ON OPERATOR/IMPC LIST",
    "app.selection.admin.list.operator.title.label": "SELECT ON OPERATOR LIST",
    "app.selection.admin.list.location.title.label": "SELECT ON LOCATION LIST",
    "app.selection.admin.list.despatchtype.title.label":
      "SELECT ON DESPATCH TYPE LIST",
    "app.selection.admin.list.operatormailbox.title.label":
      "SELECT ON OPERATOR/MAILBOX LIST",
    "app.selection.admin.list.mrdimpc.title.label": "SELECT ON MRD IMPC LIST",
    "app.report.show.mailboxes": "Show Mailboxes",
    "app.report.download": "Download",
    "app.report.csv.download": "CSV Download",
    "app.report.pdf": "Pdf",
    "app.report.save": "Save",
    "app.report.save.form.title": "Save report",
    "app.report.graph": " ",
    "app.report.include.traffic.button": "Include internal traffic",
    "app.report.exclude.traffic.button": "Exclude internal traffic",
    "app.report.include.mrdLike.button": "Include MRD-like",
    "app.report.exclude.mrdLike.button": "Exclude MRD-like",
    "app.report.include.etoe.button": "Include ETOE",
    "app.report.exclude.etoe.button": "Exclude ETOE",
    "app.report.generated.on":
      "Generated on {date} at {time} UTC (total of {totals} records)",
    "app.warning.load.from.type.c.reports":
      "Please click on a link to see the details.",
    "app.warning.load.from.summary.report":
      "Please click on a link in the summary report.",
    "app.warning.delete.save.operator.selection":
      "Do you want to delete this saved selection?",
    "app.warning.save.new.overwrite.operator.selection":
      "A new preset is going to be created. Do you confirm?",
    "app.warning.save.overwrite.operator.selection":
      "Do you want to overwrite the existing preset?",
    "app.warning.delete.category.admin": "Do you want to delete this category?",
    "app.warning.download.limitation":
      "Export will be limited to first 300000 rows. Proceed Y/N?",
    "app.warning.download.loading": "Preparing download...",
    "app.warning.change.tab.without.save":
      "There might be changes which have not been saved. All changes will be lost. Do you wish to leave this page?",
    "app.warning.report.async.ready":
      "The on screen results are limited to {totals} rows. The link to download the full report will be sent to you at your registered e-mail address when the report is ready.",
    "filter-component.action.filter": "Filter",
    "filter-component.action.apply": "Apply",
    "filter-component.action.clear-filter": "Clear",
    "filter-component.action.cancel": "Cancel",
    "filter-component.label.equals": "Equals",
    "filter-component.label.greater-than": "Greater than",
    "filter-component.label.greater-than-equal-to": "Greater than or equal to",
    "filter-component.label.smaller-than": "Smaller than",
    "filter-component.label.smaller-than-equal-to": "Smaller than or equal to",
    "filter-component.label.between": "Between",
    "filter-component.label.contains": "Contains",
    "filter-component.label.starts-with": "Starts with",
    "app.button.default-launch-page": "Set Default Launch Page",
    "app.report.clipboard": "Clipboard",
    "app.admin.edit.preset.warning.message":
      "A preset with this name already exists.",
    /* eslint-enable max-len */
  },
};
